var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal fade hidden-print",
        attrs: { "data-name": "prepare", tabindex: "-1", role: "dialog" }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-lg",
            staticStyle: {
              width: "100%",
              "padding-left": "15px",
              "max-width": "1550px"
            }
          },
          [
            _c(
              "div",
              { staticClass: "modal-content", staticStyle: { width: "100%" } },
              [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        "aria-label": "Close"
                      },
                      on: {
                        click: function($event) {
                          return _vm.reset()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "modal-title" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.trans("warehouseman.prepare.title")) +
                        "\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading == 0,
                        expression: "loading == 0"
                      }
                    ]
                  },
                  [
                    _c("div", { staticClass: "modal-body compact-errors" }, [
                      _c(
                        "div",
                        {
                          staticClass: "row",
                          staticStyle: { "margin-bottom": "5px" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "col-md-6" },
                            [
                              !_vm.areCheckedShifts
                                ? _c("dc-core-single-select", {
                                    attrs: {
                                      checked: _vm.form.data.warehouseFrom,
                                      options: _vm.warehouses,
                                      errors: _vm.form.options.errors,
                                      name: "warehouseFromId",
                                      "show-labels": false,
                                      "custom-label": _vm.translateListObj,
                                      title: _vm.trans(
                                        "warehouseman.prepare.search.warehouse_from"
                                      )
                                    },
                                    model: {
                                      value: _vm.form.data.warehouseFrom,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.data,
                                          "warehouseFrom",
                                          $$v
                                        )
                                      },
                                      expression: "form.data.warehouseFrom"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.areCheckedShifts
                                ? _c("div", { staticClass: "row form-group" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-7 control-label" },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.trans(
                                                "warehouseman.prepare.search.warehouse_from"
                                              )
                                            ) +
                                            "\n                                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-5" }, [
                                      _vm.warehouseFrom
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.warehouseFrom.name)
                                            )
                                          ])
                                        : _vm._e()
                                    ])
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.form.data.externalIssue
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: { "margin-bottom": "5px" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "col-md-6" },
                                [
                                  !_vm.areCheckedShifts
                                    ? _c("dc-core-single-select", {
                                        attrs: {
                                          checked: _vm.form.data.warehouseTo,
                                          options: _vm.warehouses,
                                          errors: _vm.form.options.errors,
                                          name: "warehouseToId",
                                          "show-labels": false,
                                          "custom-label": _vm.translateListObj,
                                          title: _vm.trans(
                                            "warehouseman.prepare.search.warehouse_to"
                                          )
                                        },
                                        model: {
                                          value: _vm.form.data.warehouseTo,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form.data,
                                              "warehouseTo",
                                              $$v
                                            )
                                          },
                                          expression: "form.data.warehouseTo"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.areCheckedShifts
                                    ? _c(
                                        "div",
                                        { staticClass: "row form-group" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-7 control-label"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.trans(
                                                      "warehouseman.prepare.search.warehouse_to"
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-5" },
                                            [
                                              _vm.warehouseTo
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.warehouseTo.name
                                                      )
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.areCheckedShifts
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: { "margin-bottom": "5px" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "col-md-6" },
                                [
                                  _c("checkbox", {
                                    attrs: {
                                      label: _vm.trans(
                                        "warehouseman.prepare.search.external_issue"
                                      )
                                    },
                                    model: {
                                      value: _vm.form.data.externalIssue,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.data,
                                          "externalIssue",
                                          $$v
                                        )
                                      },
                                      expression: "form.data.externalIssue"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("table", { staticClass: "table table-condensed" }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.trans(
                                    "warehouseman.prepare.table.object_type"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.trans(
                                    "warehouseman.prepare.table.position"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.trans("warehouseman.prepare.table.unit")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.trans("warehouseman.prepare.table.meal")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.trans(
                                    "warehouseman.prepare.table.expected"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.trans(
                                    "warehouseman.prepare.table.prepared"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.trans(
                                    "warehouseman.prepare.table.prepare"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.trans("warehouseman.prepare.table.weight")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.trans(
                                    "warehouseman.prepare.table.description"
                                  )
                                )
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.form.data.shifts, function(shift, i) {
                            return _c("tr", { key: i }, [
                              _c(
                                "td",
                                [
                                  !shift.item.id
                                    ? _c("singleselect-simple", {
                                        attrs: {
                                          options: _vm.objectTypes,
                                          "show-labels": false,
                                          "custom-label":
                                            _vm.translateObjectType,
                                          "allow-empty": false
                                        },
                                        model: {
                                          value: shift.objectType,
                                          callback: function($$v) {
                                            _vm.$set(shift, "objectType", $$v)
                                          },
                                          expression: "shift.objectType"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  shift.item.id
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.translateObjectType(
                                                shift.item.objectType
                                              )
                                            ) +
                                            "\n                                    "
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  !shift.item.id && shift.objectType
                                    ? _c("singleselect-simple", {
                                        attrs: {
                                          options:
                                            shift.objectType &&
                                            _vm.objects[shift.objectType]
                                              ? _vm.objects[shift.objectType]
                                              : [],
                                          "show-labels": false,
                                          "custom-label": _vm.translateObject,
                                          "allow-empty": false
                                        },
                                        on: {
                                          dispatch: function($event) {
                                            return _vm.updateObject(
                                              { $event: $event },
                                              i
                                            )
                                          }
                                        },
                                        model: {
                                          value: shift.object,
                                          callback: function($$v) {
                                            _vm.$set(shift, "object", $$v)
                                          },
                                          expression: "shift.object"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !shift.item.id && !shift.objectType
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.trans(
                                                "warehouseman.common.first_choose_object_type"
                                              )
                                            ) +
                                            "\n                                    "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  shift.item.id
                                    ? _c("span", [
                                        _c("i", [
                                          _vm._v(_vm._s(shift.objectName))
                                        ])
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                shift.item.id
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.translateUnit(shift.item.unit)
                                          ) +
                                          "\n                                    "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !shift.item.id
                                  ? _c("span", [
                                      shift.object
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.translateUnit(
                                                    shift.object.unit
                                                      ? shift.object.unit
                                                      : "piece"
                                                  )
                                                ) +
                                                "\n                                        "
                                            )
                                          ])
                                        : _c("span", [_vm._v("-")])
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("singleselect-simple", {
                                    attrs: {
                                      checked: shift.mealId,
                                      options: _vm.meals,
                                      label: "nameForSelect"
                                    },
                                    on: {
                                      dispatch: function($event) {
                                        return _vm.updateMealName(
                                          { $event: $event },
                                          i
                                        )
                                      }
                                    },
                                    model: {
                                      value: shift.mealId,
                                      callback: function($$v) {
                                        _vm.$set(shift, "mealId", $$v)
                                      },
                                      expression: "shift.mealId"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(shift.item.amountExpected))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    shift.item.amountPrepared
                                      ? shift.item.amountPrepared
                                      : 0
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: shift.amountPrepare,
                                      expression: "shift.amountPrepare"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "number",
                                    value: "shift.item.amountPrepare"
                                  },
                                  domProps: { value: shift.amountPrepare },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        shift,
                                        "amountPrepare",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      shift.amountPrepare
                                        ? _vm.dcNumberFormat(
                                            shift.item.unitWeight *
                                              shift.amountPrepare
                                          )
                                        : 0
                                    ) +
                                    "\n                                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: shift.description,
                                      expression: "shift.description"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { rows: "1" },
                                  domProps: { value: shift.description },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        shift,
                                        "description",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          }),
                          0
                        )
                      ]),
                      _vm._v(" "),
                      _vm.form.options.errors.shifts
                        ? _c("div", { staticClass: "has-error" }, [
                            _c("span", { staticClass: "help-block" }, [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans(
                                      "warehouseman.common.table.fill_all_fields"
                                    )
                                  )
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              on: {
                                click: function($event) {
                                  return _vm.add()
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-plus" }),
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.trans(
                                      "warehouseman.common.table.add_position"
                                    )
                                  ) +
                                  "\n                                "
                              )
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.print()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-print" }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.trans("warehouseman.common.print")) +
                              "\n                        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-success spinner",
                          attrs: {
                            type: "button",
                            "data-loading-text": _vm.loadingText
                          },
                          on: {
                            click: function($event) {
                              return _vm.execute()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-cart-arrow-down" }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.trans("warehouseman.prepare.execute")
                              ) +
                              "\n                        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.areCheckedShifts
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-success spinner",
                              attrs: {
                                type: "button",
                                "data-loading-text": _vm.loadingText
                              },
                              on: {
                                click: function($event) {
                                  return _vm.execute(true)
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-cart-arrow-down" }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.trans(
                                      "warehouseman.prepare.execute_and_close"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default",
                          attrs: { type: "button", "data-dismiss": "modal" },
                          on: {
                            click: function($event) {
                              return _vm.reset()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.trans("warehouseman.common.close")) +
                              "\n                        "
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading > 0,
                        expression: "loading > 0"
                      }
                    ],
                    staticClass: "modal-body"
                  },
                  [
                    _c(
                      "span",
                      [
                        _c("h2", [
                          _vm._v(_vm._s(_vm.trans("form.please_wait")) + "...")
                        ]),
                        _vm._v(" "),
                        _c("ring-loader")
                      ],
                      1
                    )
                  ]
                )
              ]
            )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "print-block hide",
        attrs: { id: "print_prepare", "data-name": "prepare" }
      },
      [
        _c("table", { staticClass: "table", staticStyle: { width: "50%" } }, [
          _c("tr", [
            _c("th", [
              _vm._v(
                _vm._s(_vm.trans("warehouseman.prepare.search.warehouse_from"))
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                _vm._s(
                  _vm.form.data.warehouseFrom
                    ? _vm.form.data.warehouseFrom.name
                    : "-"
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [
              _vm._v(
                _vm._s(_vm.trans("warehouseman.prepare.search.warehouse_to"))
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                _vm._s(
                  _vm.form.data.warehouseTo
                    ? _vm.form.data.warehouseTo.name
                    : "-"
                )
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "table",
          { staticClass: "table", staticStyle: { "margin-top": "30px" } },
          [
            _c("thead", [
              _c("tr", [
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.trans("warehouseman.prepare.table.object_type"))
                  )
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.trans("warehouseman.prepare.table.position"))
                  )
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(_vm._s(_vm.trans("warehouseman.prepare.table.unit")))
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(_vm._s(_vm.trans("warehouseman.prepare.table.meal")))
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.trans("warehouseman.prepare.table.expected"))
                  )
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.trans("warehouseman.prepare.table.prepared"))
                  )
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.trans("warehouseman.prepare.table.prepare"))
                  )
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.trans("warehouseman.prepare.table.description"))
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.form.data.shifts, function(shift, i) {
                return _c("tr", { key: i }, [
                  _c("td", [
                    _vm._v(_vm._s(_vm.translateObjectType(shift.objectType)))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        shift.item.id
                          ? shift.objectName
                          : shift.object
                          ? shift.object.name
                          : "-"
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(_vm._s(_vm.translateUnit(shift.item.unit)))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(_vm._s(shift.mealName ? shift.mealName : "-"))
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(shift.item.amountExpected))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        shift.item.amountPrepared
                          ? shift.item.amountPrepared
                          : 0
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(shift.amountPrepare))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(shift.description))])
                ])
              }),
              0
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f200b28", { render: render, staticRenderFns: staticRenderFns })
  }
}